export default __webpack_public_path__ + "static/media/5.e31e45a3.svg";